import * as _ from 'lodash';
import createSelector from 'selectorator';

import { ReduxStore } from '../store';

const getUsers = createSelector(['users.users']);
const getUserList = createSelector([getUsers], _.values);
const getUpdatingUsers = (state: ReduxStore) => state.users.updatingUsers;

const userSelectors = {
  getUsers,
  getUserList,
  getStatus: createSelector(['users.status']),
  getCurrentUser: (state: ReduxStore, props) => state.users.users[props.userId || window.user.id] || null,
  getUser: (state: ReduxStore, userId: number) => userId ? state.users.users[userId] : undefined,
  getUpdatingUsers,
};

export default userSelectors;
